/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseCustomerDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePaginatedResponseDTOCustomerDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseVoid } from '../backend/model';
// @ts-ignore
import type { CreateCustomerRequestDTO } from '../backend/model';
// @ts-ignore
import type { SendEmailToCustomerRequestDTO } from '../backend/model';
// @ts-ignore
import type { UpdateCustomerRequestDTO } from '../backend/model';
/**
 * CouncilCustomerApi - axios parameter creator
 * @export
 */
export const CouncilCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Create a new customer for a council
         * @param {string} councilId 
         * @param {CreateCustomerRequestDTO} createCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (councilId: string, createCustomerRequestDTO: CreateCustomerRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('createCustomer', 'councilId', councilId)
            // verify required parameter 'createCustomerRequestDTO' is not null or undefined
            assertParamExists('createCustomer', 'createCustomerRequestDTO', createCustomerRequestDTO)
            const localVarPath = `/api/council/{councilId}/customers`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Delete a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouncilCustomer: async (councilId: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('deleteCouncilCustomer', 'councilId', councilId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCouncilCustomer', 'customerId', customerId)
            const localVarPath = `/api/council/{councilId}/customers/{customerId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilCustomer: async (councilId: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilCustomer', 'councilId', councilId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCouncilCustomer', 'customerId', customerId)
            const localVarPath = `/api/council/{councilId}/customers/{customerId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get customers for a specific council with filtering and pagination
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilCustomers: async (councilId: string, search?: string, status?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilCustomers', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/customers`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Send email to a specific customer
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {SendEmailToCustomerRequestDTO} sendEmailToCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailToCustomer: async (councilId: string, customerId: string, sendEmailToCustomerRequestDTO: SendEmailToCustomerRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('sendEmailToCustomer', 'councilId', councilId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendEmailToCustomer', 'customerId', customerId)
            // verify required parameter 'sendEmailToCustomerRequestDTO' is not null or undefined
            assertParamExists('sendEmailToCustomer', 'sendEmailToCustomerRequestDTO', sendEmailToCustomerRequestDTO)
            const localVarPath = `/api/council/{councilId}/customers/{customerId}/email`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailToCustomerRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilCustomer: async (councilId: string, customerId: string, updateCustomerRequestDTO: UpdateCustomerRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateCouncilCustomer', 'councilId', councilId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCouncilCustomer', 'customerId', customerId)
            // verify required parameter 'updateCustomerRequestDTO' is not null or undefined
            assertParamExists('updateCouncilCustomer', 'updateCustomerRequestDTO', updateCustomerRequestDTO)
            const localVarPath = `/api/council/{councilId}/customers/{customerId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilCustomerApi - functional programming interface
 * @export
 */
export const CouncilCustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilCustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Create a new customer for a council
         * @param {string} councilId 
         * @param {CreateCustomerRequestDTO} createCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(councilId: string, createCustomerRequestDTO: CreateCustomerRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(councilId, createCustomerRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilCustomerApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Delete a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCouncilCustomer(councilId: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCouncilCustomer(councilId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilCustomerApi.deleteCouncilCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilCustomer(councilId: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCustomerDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilCustomer(councilId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilCustomerApi.getCouncilCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get customers for a specific council with filtering and pagination
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilCustomers(councilId: string, search?: string, status?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePaginatedResponseDTOCustomerDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilCustomers(councilId, search, status, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilCustomerApi.getCouncilCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Send email to a specific customer
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {SendEmailToCustomerRequestDTO} sendEmailToCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailToCustomer(councilId: string, customerId: string, sendEmailToCustomerRequestDTO: SendEmailToCustomerRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailToCustomer(councilId, customerId, sendEmailToCustomerRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilCustomerApi.sendEmailToCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouncilCustomer(councilId: string, customerId: string, updateCustomerRequestDTO: UpdateCustomerRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouncilCustomer(councilId, customerId, updateCustomerRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilCustomerApi.updateCouncilCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilCustomerApi - factory interface
 * @export
 */
export const CouncilCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilCustomerApiFp(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Create a new customer for a council
         * @param {string} councilId 
         * @param {CreateCustomerRequestDTO} createCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(councilId: string, createCustomerRequestDTO: CreateCustomerRequestDTO, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createCustomer(councilId, createCustomerRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Delete a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouncilCustomer(councilId: string, customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.deleteCouncilCustomer(councilId, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilCustomer(councilId: string, customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCustomerDTO> {
            return localVarFp.getCouncilCustomer(councilId, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get customers for a specific council with filtering and pagination
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilCustomers(councilId: string, search?: string, status?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePaginatedResponseDTOCustomerDTO> {
            return localVarFp.getCouncilCustomers(councilId, search, status, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Send email to a specific customer
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {SendEmailToCustomerRequestDTO} sendEmailToCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailToCustomer(councilId: string, customerId: string, sendEmailToCustomerRequestDTO: SendEmailToCustomerRequestDTO, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.sendEmailToCustomer(councilId, customerId, sendEmailToCustomerRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific customer for a council
         * @param {string} councilId 
         * @param {string} customerId 
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilCustomer(councilId: string, customerId: string, updateCustomerRequestDTO: UpdateCustomerRequestDTO, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateCouncilCustomer(councilId, customerId, updateCustomerRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilCustomerApi - object-oriented interface
 * @export
 * @class CouncilCustomerApi
 * @extends {BaseAPI}
 */
export class CouncilCustomerApi extends BaseAPI {
    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Create a new customer for a council
     * @param {string} councilId 
     * @param {CreateCustomerRequestDTO} createCustomerRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilCustomerApi
     */
    public createCustomer(councilId: string, createCustomerRequestDTO: CreateCustomerRequestDTO, options?: RawAxiosRequestConfig) {
        return CouncilCustomerApiFp(this.configuration).createCustomer(councilId, createCustomerRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Delete a specific customer for a council
     * @param {string} councilId 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilCustomerApi
     */
    public deleteCouncilCustomer(councilId: string, customerId: string, options?: RawAxiosRequestConfig) {
        return CouncilCustomerApiFp(this.configuration).deleteCouncilCustomer(councilId, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get a specific customer for a council
     * @param {string} councilId 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilCustomerApi
     */
    public getCouncilCustomer(councilId: string, customerId: string, options?: RawAxiosRequestConfig) {
        return CouncilCustomerApiFp(this.configuration).getCouncilCustomer(councilId, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get customers for a specific council with filtering and pagination
     * @param {string} councilId 
     * @param {string} [search] 
     * @param {string} [status] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilCustomerApi
     */
    public getCouncilCustomers(councilId: string, search?: string, status?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return CouncilCustomerApiFp(this.configuration).getCouncilCustomers(councilId, search, status, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Send email to a specific customer
     * @param {string} councilId 
     * @param {string} customerId 
     * @param {SendEmailToCustomerRequestDTO} sendEmailToCustomerRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilCustomerApi
     */
    public sendEmailToCustomer(councilId: string, customerId: string, sendEmailToCustomerRequestDTO: SendEmailToCustomerRequestDTO, options?: RawAxiosRequestConfig) {
        return CouncilCustomerApiFp(this.configuration).sendEmailToCustomer(councilId, customerId, sendEmailToCustomerRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Update a specific customer for a council
     * @param {string} councilId 
     * @param {string} customerId 
     * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilCustomerApi
     */
    public updateCouncilCustomer(councilId: string, customerId: string, updateCustomerRequestDTO: UpdateCustomerRequestDTO, options?: RawAxiosRequestConfig) {
        return CouncilCustomerApiFp(this.configuration).updateCouncilCustomer(councilId, customerId, updateCustomerRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

